import { render, staticRenderFns } from "./CustomUnorderedList.vue?vue&type=template&id=34227f63&scoped=true&"
import script from "./CustomUnorderedList.vue?vue&type=script&lang=js&"
export * from "./CustomUnorderedList.vue?vue&type=script&lang=js&"
import style0 from "./CustomUnorderedList.vue?vue&type=style&index=0&id=34227f63&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34227f63",
  null
  
)

export default component.exports